// 同意文言編集完了
import React, { useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../../BrowserBack';
import { maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';

const ClauseComplete = () => {
  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  return (
    <Maintenance active={maintenance_type.clauses}>
      <div className="page-title">同意文言編集(完了)</div>
      <div className="complete-message">同意文言の編集が完了しました。</div>
      <div className="footer-btn">
        <a
          href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause`}
          className="btn btn-mini btn-success"
        >
          次へ
        </a>
      </div>
    </Maintenance>
  );
};

if (document.getElementById('clause-complete')) {
  render(<ClauseComplete />, document.getElementById('clause-complete'));
}
